import type { TimerState } from "@/types"

/**
 * Remaining time is always computed from the shared `TimerState` rather than
 * tracked in a local countdown, so every client agrees. A ticking UI should
 * re-render on an interval and call these with a fresh `now`.
 */
export function timerElapsedMs(timer: TimerState, now: number = Date.now()): number {
  const currentSegment =
    timer.status === "running" && timer.startedAt !== null ? Math.max(now - timer.startedAt, 0) : 0
  return Math.min(timer.elapsedMs + currentSegment, timer.durationMs)
}

export function timerRemainingMs(timer: TimerState, now: number = Date.now()): number {
  return Math.max(timer.durationMs - timerElapsedMs(timer, now), 0)
}

export function isTimerExpired(timer: TimerState, now: number = Date.now()): boolean {
  return timer.durationMs > 0 && timerRemainingMs(timer, now) === 0
}

/** Formats milliseconds as `m:ss`. */
export function formatDuration(ms: number): string {
  const totalSeconds = Math.max(Math.floor(ms / 1000), 0)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${String(seconds).padStart(2, "0")}`
}

export function minutesToMs(minutes: number): number {
  return minutes * 60 * 1000
}
